export const EFFECTS_SDK_ASSETS = 'https://assets.100ms.live/effectsdk/3.6.2/';
